import { Content } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Detail, DetailGroup } from 'src/modals/common';
import { MarketplacePaymentLines } from 'src/modals/SaleDetails/components/MarketplacePaymentSection/MarketplacePaymentLines';
import { useShouldHideForWastedSale } from 'src/modals/SaleDetails/hooks/useShouldHideForWastedSale';
import { ContentId } from 'src/utils/constants/contentId';
import { SALES_STATUS_TO_CID } from 'src/utils/constants/contentIdMaps';
import { Feature, Permission, SaleDetails } from 'src/WebApiController';

export const MarketplacePaymentSection = ({
  sale,
}: {
  sale?: SaleDetails | null;
}) => {
  const hasMarketplacePaymentLinesDisplayFeature = useUserHasFeature(
    Feature.MarketplacePaymentLinesDisplay
  );
  const hasManageMarketplacePaymentFeature = useUserHasFeature(
    Feature.ManageMarketplacePayment
  );

  const hasViewMarketplacePaymentLinesPermission = useUserHasAnyOfPermissions(
    Permission.Accounting_ViewAll,
    Permission.Accounting_ViewPaymentsOnSale
  );

  const canViewMarketplacePaymentLines =
    hasViewMarketplacePaymentLinesPermission &&
    (hasMarketplacePaymentLinesDisplayFeature ||
      hasManageMarketplacePaymentFeature);

  const hideForWastedSale = useShouldHideForWastedSale(sale);

  return (
    <Stack direction="column" gap="l">
      <DetailGroup
        style={{ flexDirection: hideForWastedSale ? 'row' : 'column' }}
      >
        {hideForWastedSale && sale?.status && (
          <Detail
            label={<Content id={ContentId.Status} />}
            detail={<Content id={SALES_STATUS_TO_CID[sale.status]} />}
          />
        )}
      </DetailGroup>
      {canViewMarketplacePaymentLines && sale && (
        <MarketplacePaymentLines
          sale={sale}
          canManageMarketplacePayment={hasManageMarketplacePaymentFeature}
        />
      )}
    </Stack>
  );
};
